export default __webpack_public_path__ + "f3692f96a16a96236ebe834fb4d9640f.png";